import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../features/auth/authSlice'
import applicationReducer from '../features/application/applicationSlice'
import dependenciesReducer from '../features/dependencies/dependenciesSlice'
import databaseReducer from '../features/database/databaseSlice'
import jobsReducer from '../features/jobs/jobsSlice'
import servicesReducer from '../features/services/servicesSlice'
import pipelineReducer from '../features/pipeline/pipelineSlice'
import userPermissionsReducer from '../features/userPermissions/userPermissionsSlice'

const store = configureStore({
  reducer: {
    auth: authReducer,
    application: applicationReducer,
    dependencies: dependenciesReducer,
    database: databaseReducer,
    jobs: jobsReducer,
    services: servicesReducer,
    pipelines: pipelineReducer,
    userPermissions: userPermissionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
